import http from '@/utils/http-common'
import { buildSecurityAlertQuery } from './security-alert-domain.mjs'

const RECIPIENTS_URL = 'annotation/security-alert-recipients/'
const NOTIFICATIONS_URL = 'annotation/security-alert-notification/'
const ALERTS_URL = 'annotation/security-alert/'
const silentConfig = { suppressGlobalErrorToast: true }

function pageResponse(response) {
  const data = response.data || {}
  return {
    results: Array.isArray(data.results) ? data.results : [],
    count: Number(data.count || 0),
    next: data.next || null,
    previous: data.previous || null,
  }
}

export async function getSecurityAlerts(filters = {}) {
  const response = await http.get(ALERTS_URL, {
    ...silentConfig,
    params: buildSecurityAlertQuery(filters),
  })
  return pageResponse(response)
}

export async function getSecurityAlert(id) {
  const response = await http.get(`${ALERTS_URL}${id}/`, silentConfig)
  return response.data
}

export async function acknowledgeSecurityAlert(id, actionNote = '') {
  const response = await http.post(`${ALERTS_URL}${id}/acknowledge/`, {
    action_note: actionNote,
  }, silentConfig)
  return response.data
}

export async function resolveSecurityAlert(id, actionNote) {
  const response = await http.post(`${ALERTS_URL}${id}/resolve/`, {
    action_note: actionNote,
  }, silentConfig)
  return response.data
}

export async function getSecurityAlertActors(options = {}) {
  const params = options.organizationRoot
    ? { organization_pk: options.organizationRoot, include_children: true }
    : {}
  const response = await http.get('account/user_info/', { ...silentConfig, params })
  return Array.isArray(response.data) ? response.data : []
}

export async function getSecurityAlertOrganizations() {
  const response = await http.get('account/organization/', silentConfig)
  return Array.isArray(response.data) ? response.data : []
}

export async function getSecurityAlertRecipients() {
  const response = await http.get(RECIPIENTS_URL, silentConfig)
  return response.data?.recipients || []
}

export async function getSecurityAlertRecipientCandidates() {
  const response = await http.get(`${RECIPIENTS_URL}candidates/`, silentConfig)
  return response.data?.candidates || []
}

export async function patchSecurityAlertRecipients(payload) {
  const response = await http.patch(RECIPIENTS_URL, payload, silentConfig)
  return response.data?.recipients || []
}

export async function sendSecurityAlertConfirmation() {
  const response = await http.post(`${RECIPIENTS_URL}confirmation/`, {}, silentConfig)
  return response.data || {}
}

export async function getSecurityAlertNotifications(options = {}) {
  const response = await http.get(NOTIFICATIONS_URL, {
    ...silentConfig,
    params: {
      page: Math.max(1, Number(options.page) || 1),
      page_size: Math.min(100, Math.max(1, Number(options.pageSize) || 30)),
    },
  })
  return pageResponse(response)
}

export async function getAllSecurityAlertNotifications() {
  const pageSize = 100
  const first = await getSecurityAlertNotifications({ page: 1, pageSize })
  const maxPage = Math.max(1, Math.ceil(first.count / pageSize))
  const results = first.results.slice()
  for (let page = 2; page <= maxPage; page += 1) {
    const current = await getSecurityAlertNotifications({ page, pageSize })
    results.push(...current.results)
  }
  return results
}

export async function markSecurityAlertRead(id) {
  const response = await http.post(`${NOTIFICATIONS_URL}${id}/read/`, {}, silentConfig)
  return response.data
}

export async function markSecurityAlertsReadMultiple(notificationIds) {
  const response = await http.post(`${NOTIFICATIONS_URL}read-multiple/`, {
    notification_ids: notificationIds,
  }, silentConfig)
  return response.data
}

export async function markAllSecurityAlertsRead() {
  const response = await http.post(`${NOTIFICATIONS_URL}read-all/`, {}, silentConfig)
  return response.data
}
